import { Stack } from "@mui/material";
import { useCallback } from "react";
import { useNavigate } from "react-router";
import { useCurrentTileContext } from "../contexts/CurrentTileContext";
import type { TileObject } from "../models/TileObject";
import { canEditWidget, canMaximizeWidget } from "../utils/widgetVisibility";
import TileHeader from "./TileHeader";
import WidgetRenderer from "./WidgetRenderer";

interface WidgetRendererProps {
  tile: TileObject;
}

const TileRenderer = ({ tile }: WidgetRendererProps) => {
  const navigate = useNavigate();
  const { hover } = useCurrentTileContext();

  const handleOpenFullscreen = useCallback(() => {
    navigate(`./widgets/${tile.id}`);
  }, [tile.id, navigate]);

  return (
    <Stack
      spacing={tile.item.widget.hideTitle ? 0 : 1.5}
      useFlexGap
      sx={{
        flex: 1,
        maxHeight: "100%",
        overflow: "hidden",
      }}
    >
      <TileHeader
        tile={tile.item}
        hover={hover === true}
        showMaximizeButton={true}
        menuPlacement="overlay"
        onOpenFullscreen={handleOpenFullscreen}
        shouldShowMaximize={canMaximizeWidget}
        shouldShowEdit={canEditWidget}
      />
      <Stack sx={{ flex: 1 }}>
        <WidgetRenderer widget={tile.item.widget} />
      </Stack>
    </Stack>
  );
};

export default TileRenderer;
